import { useEffect, useRef, useState } from 'react';

// EXPERIMENT (2026-08-01): gamified reinforcement on the Trainer eval page —
// a short burst of green up-arrows when improvements manifest. Deliberately
// self-contained so removal is: delete this file + the two callsites in
// AiChatPage.tsx (search "CelebrationBurst"). No styles, prefs, or state
// live anywhere else.

const ARROW_COUNT = 6;

/** Renders an absolutely-positioned, pointer-transparent burst of rising
 *  arrows inside the nearest `relative` ancestor. Fires once each time
 *  `fireKey` changes to a new non-null value; null never fires. */
export function CelebrationBurst({ fireKey }: { fireKey: string | null }) {
  const [burst, setBurst] = useState(0);
  const last = useRef<string | null>(null);

  useEffect(() => {
    if (fireKey !== null && fireKey !== last.current) {
      last.current = fireKey;
      setBurst((n) => n + 1);
    }
  }, [fireKey]);

  if (burst === 0) return null;
  return (
    <span
      key={burst}
      aria-hidden
      className="tres-celebrate pointer-events-none absolute inset-0"
    >
      <style>{`
        @keyframes tres-celebrate-rise {
          0% { transform: translateY(8px) scale(0.6); opacity: 0; }
          25% { opacity: 0.95; }
          100% { transform: translateY(-36px) scale(1.05); opacity: 0; }
        }
        .tres-celebrate svg {
          position: absolute;
          bottom: 0;
          animation: tres-celebrate-rise 900ms ease-out forwards;
          opacity: 0;
        }
        @media (prefers-reduced-motion: reduce) {
          .tres-celebrate { display: none; }
        }
      `}</style>
      {Array.from({ length: ARROW_COUNT }, (_, i) => (
        <svg
          key={i}
          viewBox="0 0 12 12"
          width="12"
          height="12"
          className="text-tres-status-active"
          style={{ left: `${6 + i * 16}%`, animationDelay: `${i * 90}ms` }}
        >
          <path d="M6 1 L11 7 H8 V11 H4 V7 H1 Z" fill="currentColor" />
        </svg>
      ))}
    </span>
  );
}
